import './src/styles/global.css'

// Always land at the top of the page on a fresh load or reload, unless the URL
// points at a specific section (e.g. /#treatments).
export const onClientEntry = () => {
  if (typeof window === 'undefined') return
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}

export const onInitialClientRender = () => {
  if (typeof window === 'undefined' || window.location.hash) return
  window.scrollTo(0, 0)
  // Some browsers restore the old offset a frame after hydration.
  window.requestAnimationFrame(() => window.scrollTo(0, 0))
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return true
  return [0, 0]
}
